import { FormEvent } from 'react';
import useAsyncFn from 'react-use/lib/useAsyncFn';

export type DialogSubmitEvent = FormEvent<HTMLElement> & {
  submitter?: HTMLElement;
};

export type DialogSubmitHandler = (
  event: DialogSubmitEvent,
) => void | Promise<void>;

export const useDialogForm = (
  onSubmit: DialogSubmitHandler | undefined,
  onClose: () => void,
) =>
  useAsyncFn(
    async (event: FormEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();

      // Calling `preventDefault` on the handed-over event means "keep the dialog
      // open", not "cancel the submit" — that already happened above.
      let keepOpen = false;
      const dialogEvent = Object.assign(
        Object.create(event) as DialogSubmitEvent,
        {
          preventDefault: () => {
            keepOpen = true;
          },
          submitter:
            (event.nativeEvent as SubmitEvent | undefined)?.submitter ??
            undefined,
        },
      );

      await onSubmit?.(dialogEvent);

      if (!keepOpen) {
        onClose();
      }
    },
    [onSubmit, onClose],
  );
